// extracted by mini-css-extract-plugin
module.exports = {"Content":"e47xAk4wKw4RHTQ4IRmEO"};